// extracted by mini-css-extract-plugin
export default {"page":"a1-z","cartModal":"b1-z","checkout":"c1-z","placeholder":"d1-z","account":"e1-z"};